import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tooltip, Whisper } from 'rsuite';
import { icons } from '@shared/static/icons';
import { copyToClipboard } from '@utils/helpers';

export default function ReferralsCopyLink() {
  const { t } = useTranslation();
  const { statistic } = useSelector((state) => state.referrals);
  const link = statistic?.referral_link ?? '';
  const whisperRef = useRef();
  const timerRef = useRef();

  useEffect(() => () => clearTimeout(timerRef.current), []);

  function handleOpen() {
    copyToClipboard(link);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => whisperRef.current?.close(), 1000);
  }

  return (
    <div className="referralsCopy">
      <p className="secondary-text">{t('Referral link')}</p>
      <Whisper
        placement="top"
        controlId="control-id-click"
        trigger="click"
        speaker={<Tooltip>{t('referral_link_copied')}</Tooltip>}
        ref={whisperRef}
        onOpen={handleOpen}
      >
        <button type="button" className="referralsCopy__link body-14m">
          {icons.copy}
          {link.replace(/^https?:\/\//, '')}
        </button>
      </Whisper>
    </div>
  );
}
